<template>
  <div>
    <el-row v-if="liveInfo.courseType == 3">
      <el-col :span="24">
        <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="toList()">
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row style="padding: 20px">
      <el-col :span="24">
        <el-card shadow="hover">
          <el-skeleton :loading="loading" animated>
            <template slot="template">
              <el-row>
                <el-col :span="4" style="width: 300px">
                  <el-skeleton-item variant="image" style="width: 300px; height: 224px" />
                </el-col>
                <el-col :span="12" style="padding-left: 20px">
                  <div>
                    <el-skeleton-item variant="h1" style="width: 20%" />
                  </div>
                  <div style="margin: 20px 0">
                    <el-skeleton-item variant="p" style="width: 10%; margin-right: 10px" />
                    <el-skeleton-item variant="p" style="width: 20%" />
                  </div>
                  <div style="margin: 20px 0">
                    <el-skeleton-item variant="p" style="width: 10%; margin-right: 10px" />
                    <el-skeleton-item variant="p" style="width: 20%" />
                  </div>
                  <div style="margin: 20px 0">
                    <el-skeleton-item variant="p" style="width: 10%; margin-right: 10px" />
                    <el-skeleton-item variant="p" style="width: 20%" />
                  </div>
                  <div>
                    <el-skeleton-item variant="button" class="el-skeleton-item-button" />
                    <el-skeleton-item variant="button" class="el-skeleton-item-button" />
                    <el-skeleton-item variant="button" class="el-skeleton-item-button" />
                  </div>
                </el-col>
              </el-row>
            </template>
            <template>
              <el-row>
                <el-col :span="4" style="width: 300px">
                  <el-image style="width: 300px; height: 224px" :src="liveInfo.img_url" fit="cover"></el-image>
                </el-col>
                <el-col :span="12" style="padding-left: 20px">
                  <el-descriptions :title="liveInfo.title" :column="1" :colon="false">
                    <el-descriptions-item label="直播类型：" v-if="liveInfo.live_type == 1">常规直播</el-descriptions-item>
                    <el-descriptions-item label="直播类型：" v-if="liveInfo.live_type == 4">推流直播</el-descriptions-item>
                    <el-descriptions-item label="直播类型：" v-if="liveInfo.live_type == 6">伪直播</el-descriptions-item>
                    <el-descriptions-item label="直播简介：">{{ liveInfo.intro }}</el-descriptions-item>
                    <el-descriptions-item label="直播时间：">{{ liveInfo.begin_at }} ~
                      {{ liveInfo.end_at }}
                    </el-descriptions-item>
                  </el-descriptions>
                  <div>
                    <el-button v-if="liveInfo.live_status == 0" type="info" disabled size="mini">直播流状态：未开始</el-button>
                    <el-button v-if="liveInfo.live_status == 1" type="success" disabled :loading="true" size="mini">
                      直播流状态：直播中...
                    </el-button>
                    <el-button v-if="liveInfo.live_status == 2" type="info" size="mini" disabled>直播流状态：已结束
                    </el-button>
                    <!-- <el-button v-if="liveInfo.live_status == 2 && liveInfo.allow_reset == 1" type="primary" size="small"
                               @click="resetLiveStatus()">已结束，重置
                    </el-button> -->
                    <el-button type="primary" size="mini" @click="$refs.roomInfo.getLiveRoomInfo(liveInfo.id)">
                      直播地址
                    </el-button>
                    <el-button v-if="liveInfo.live_type == 1 && 1 == 2" type="primary" size="mini"
                      @click="$refs.embedVideo.getList(liveInfo.course_id, liveInfo.id)">
                      设置插播
                    </el-button>
                    <el-button type="primary" size="mini" @click="toMessage(liveInfo.course_id, liveInfo.id)">
                      带货推广
                    </el-button>
                    <initLiveChatMessage
                      v-if="liveInfo.live_type == 6 && (liveInfo.live_status == 0 || liveInfo.live_status == 1 || (liveInfo.live_status == 2 && liveInfo.allow_reset == 1))"
                      :period_id="period_id" :live_info="liveInfo"></initLiveChatMessage>

                    <el-button
                      v-if="admin_id == 1 && liveInfo.live_status == 2 && liveInfo.allow_reset == 0 && liveInfo.bjy_video_status == 100"
                      type="warning" size="mini" @click="replacePlayback()">替换回放
                    </el-button>
                    <i class="el-icon-info"
                      v-if="admin_id == 1 && liveInfo.live_status == 2 && liveInfo.allow_reset == 0 && liveInfo.bjy_video_status == 100"
                      @click="replacePlaybackMsg()"></i>

                    <el-button
                      v-if="liveInfo.live_type == 1 && liveInfo.live_status > 0 && (Date.parse(liveInfo.end_at) > (new Date()).getTime()) && liveInfo.bjy_video_status == 0"
                      type="warning" size="mini" @click="advanceStopLive()">提前结束直播</el-button>
                    <el-button
                      v-if="liveInfo.live_type == 4 && liveInfo.live_status > 0 && (Date.parse(liveInfo.end_at) > (new Date()).getTime()) && liveInfo.bjy_video_status == 0"
                      type="warning" size="mini" @click="advanceStopLive()">提前结束直播</el-button>
                    <el-button
                      v-if="liveInfo.live_type == 6 && liveInfo.live_status > 0 && (Date.parse(liveInfo.end_at) > (new Date()).getTime()) && liveInfo.bjy_video_status == 0"
                      type="warning" size="mini" @click="advanceStopLive()">提前结束直播</el-button>

                    <el-button
                      v-if="(Date.parse(liveInfo.end_at) <= (new Date()).getTime()) && liveInfo.bjy_video_status == 0"
                      type="warning" size="mini" disabled>直播已结束，回放生成中...</el-button>
                    <el-button v-if="liveInfo.live_status == 2 && liveInfo.bjy_video_status == 20" type="warning"
                      size="mini" disabled>回放转码中...</el-button>
                    <el-button v-if="liveInfo.live_status == 2 && liveInfo.bjy_video_status == 30" type="warning"
                      size="mini" disabled>回放生成失败</el-button>
                    <el-button v-if="liveInfo.live_status == 2 && liveInfo.bjy_video_status == 100" type="warning"
                      size="mini" disabled>回放已生成</el-button>

                    <el-button v-if="liveInfo.courseType == 3 && liveInfo.configuration.is_vertical_screen == 1"
                      type="primary" size="mini" @click="toBlessingBag(liveInfo.course_id, liveInfo.id)">
                      福袋管理
                    </el-button>
                  </div>
                </el-col>
              </el-row>
            </template>
          </el-skeleton>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 20px">
        <!--        <el-card shadow="never">-->
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="用户名单" name="userList">
            <el-button type="primary" size="small" @click="userList()">刷新</el-button>
            <el-table :data="userListInfo" :stripe="true" style="width: 100%; margin-top: 15px" border
              v-loading="userListInfoLoading" size="small">
              <el-table-column prop="user_number" label="用户ID" align="center" fixed></el-table-column>
              <el-table-column prop="user_name" label="昵称" align="center" fixed></el-table-column>
              <el-table-column label="角色" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.user_role == 0 ? '学生' : (row.user_role == 1 ? '老师' : '助教') }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="reg_name" label="邀约人" align="center" fixed></el-table-column>
              <el-table-column prop="total_consume" label="累计消费" align="center" fixed></el-table-column>
              <el-table-column label="时间" align="center" width="230">
                <template slot-scope="{ row }">
                  最早进入时间：{{ row.first_time }}<br>
                  最晚离开时间：{{ row.last_time }}
                </template>
              </el-table-column>
              <el-table-column label="时间" align="center" width="250">
                <template slot-scope="{ row }">
                  上课后进入时间：{{ row.first_heartbeat_time }}<br>
                  上课后离开时间：{{ row.last_heartbeat_time }}
                </template>
              </el-table-column>
              <el-table-column label="听课时长" align="center">
                <template slot-scope="{ row }">{{ formatSeconds(row.actual_listen_time) }}</template>
              </el-table-column>
              <el-table-column label="地址" align="center">
                <template slot-scope="{ row }">{{ row.area }}{{ row.city }}</template>
              </el-table-column>
              <el-table-column label="IP" align="center">
                <template slot-scope="{ row }">{{ row.user_ip }} - {{ row.network_operator }}</template>
              </el-table-column>
              <el-table-column label="客户端" align="center">
                <template slot-scope="{ row }">
                  <span v-if="row.client_type == 0">PC网页</span>
                  <span v-else-if="row.client_type == 1">PC客户端</span>
                  <span v-else-if="row.client_type == 2">WAP站</span>
                  <span v-else-if="row.client_type == 3">IOS</span>
                  <span v-else-if="row.client_type == 4">Android</span>
                  <span v-else-if="row.client_type == 5">Mac客户端</span>
                  <span v-else>微信小程序</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 15px">
              <el-pagination layout="total, prev, pager, next, jumper" background @current-change="userList"
                :current-page.sync="userListInfoQuery.page" :page-size="userListInfoQuery.limit"
                :total="userListInfoTotal"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="中奖名单" name="prizeList">
            <el-button type="primary" size="small" @click="getAwardStatList()">刷新</el-button>
            <el-table :data="awardStatList" v-loading="awardStatListLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="id" label="抽奖ID" align="center" fixed></el-table-column>
              <el-table-column prop="award_name" label="奖品名称" align="center" fixed></el-table-column>
              <el-table-column label="抽奖类型" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.type == 0 ? '标准抽奖' : '口令抽奖' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="绑定状态" align="center">
                <template slot-scope="{ row }">
                  <span style="color:#67C23A" v-if="row.bind_status == 1">已绑定</span>
                  <span v-else>待绑定</span>
                </template>
              </el-table-column>
              <el-table-column label="发放状态" align="center">
                <template slot-scope="{ row }">
                  <span style="color:#67C23A" v-if="row.give_status == 1">已发放</span>
                  <span v-else>待发放</span>
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间" align="center" fixed></el-table-column>
              <el-table-column label="操作" align="center" width="250">
                <template slot-scope="{ row }">
                  <el-button v-if="row.bind_status == 0" type="warning" size="small"
                    @click="showBindProductDialog(row.id)">绑定中奖产品
                  </el-button>
                  <template v-else>
                    <el-button v-if="row.give_status == 0" type="danger" size="small"
                      @click="deleteLiveBindProduct(row.id)">删除绑定产品
                    </el-button>
                  </template>

                  <el-button v-if="row.bind_status == 0" type="primary" size="small"
                    @click="showAwardUser(row.award_user_list)">查看中奖名单
                  </el-button>
                  <el-button v-else type="primary" size="small" @click="showGiveProductListDialog(row.id)">中奖信息
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="签到信息" name="userCheckinInfo">
            <el-table :data="userCheckinInfo" v-loading="userCheckinInfoLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column type="expand" align="left" fixed width="51">
                <template slot-scope="props">
                  <el-table :data="props.row.user_list" :stripe="true" border style="width: 100%;border-top: none"
                    size="small">
                    <el-table-column prop="user_number" label="用户ID" align="center" fixed></el-table-column>
                    <el-table-column prop="nickname" label="用户昵称" align="center" fixed></el-table-column>
                    <el-table-column label="发放状态" align="center">
                      <template slot-scope="{ row }">
                        <span style="color:#67C23A" v-if="row.checkin == 1">已签到</span>
                        <span v-else>未签到</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column prop="time" label="签到操作时间" align="left" fixed></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="聊天信息" name="chatMsg">
            <el-button type="primary" size="small" @click="exportChatMsgExcel">导出</el-button>
            <el-table :data="chatMsg" v-loading="chatMsgLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-descriptions title="">
                    <el-descriptions-item label="详细内容">{{ props.row.content }}</el-descriptions-item>
                  </el-descriptions>
                </template>
              </el-table-column>
              <el-table-column prop="content" width="200" :show-overflow-tooltip="true" label="内容"
                align="center"></el-table-column>
              <el-table-column prop="time" label="发送时间" align="center"></el-table-column>
              <el-table-column prop="user_number" label="用户ID" align="center"></el-table-column>
              <el-table-column prop="user_name" label="用户昵称" align="center"></el-table-column>
              <el-table-column label="用户角色" align="center">
                <template slot-scope="{ row }">{{
                  row.user_role == 0 ? '学员' : (row.user_role == 1 ? '讲师' : '助教')
                }}
                </template>
              </el-table-column>
              <el-table-column prop="area" label="地址" align="center"></el-table-column>
              <el-table-column prop="ip" label="IP" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane v-if="liveInfo.live_type == 6" label="已选中聊天消息" name="fakeChatMsg">
            <el-input class="search-el" size="mini" v-model="fakeChatMsgQuery.content" clearable
              placeholder="请输入"></el-input>
            <el-select class="search-el" size="mini" v-model="fakeChatMsgQuery.status" clearable placeholder="消息状态">
              <el-option label="全部状态" value="">全部状态</el-option>
              <el-option label="待提交" value="1">待提交</el-option>
              <el-option label="已提交" value="2">已提交</el-option>
              <el-option label="发送成功" value="3">发送成功</el-option>
              <el-option label="发送失败" value="4">发送失败</el-option>
            </el-select>
            <el-button type="primary" size="mini" @click="getFakeChatMsg">查询</el-button>
            <el-button v-if="fakeChatMsgList.total > 0 && fakeChatMsgList.list[0].status == 1" type="primary"
              size="mini" @click="insertFakeQueue">提交已选中消息</el-button>
            <el-button v-if="fakeChatMsgList.total > 0" type="danger" size="mini"
              @click="cleanFakeMessage">清空伪直播假消息</el-button>
            <el-button v-if="fakeChatMsgList.total > 0 && fakeChatMsgList.list[0].status == 1" type="danger" size="mini"
              @click="dialogBatchFakeMsgTime = true;">批量调整消息时间</el-button>
            <el-table :data="fakeChatMsgList.list" v-loading="fakeChatMsgLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-descriptions title="">
                    <el-descriptions-item label="详细内容">{{ props.row.content }}</el-descriptions-item>
                  </el-descriptions>
                </template>
              </el-table-column>

              <el-table-column label="内容" align="center" width="260" :show-overflow-tooltip="true">
                <template slot-scope="{ row }">
                  <span v-if="row.content_type == 1">{{ row.content }}</span>
                  <span v-else-if="row.content_type == 2" class="demo-image__preview">
                    <el-image style="width: 45px; height: 45px" :src="row.content" :preview-src-list="[row.content]"
                      fit="cover"></el-image>
                  </span>
                  <span v-else style="display: flex; justify-content: center">
                    <span>
                      <el-image style="width: 45px; height: 45px" :src="row.content.image"
                        :preview-src-list="[row.content.image]" fit="cover"></el-image>
                    </span>
                    <span style="display: flex; flex-direction: column;text-align: left; padding-left: 5px;">
                      <span style="width: 180px; overflow: hidden; text-overflow: ellipsis;">{{ row.content.title
                        }}</span>
                      <span><a :href="row.content.address" target="_blank">查看详情</a></span>
                    </span>
                  </span>
                </template>
              </el-table-column>

              <el-table-column label="发送时间" align="center">
                <template slot-scope="{ row }">
                  <span v-if="row.send_time < 0" style="color: #ff0000">开播前</span>
                  <span v-if="row.send_time >= 0" style="color: #67c23a">开播后</span>
                  {{ formatSecondShow(row.send_time) }}
                </template>
              </el-table-column>
              <el-table-column label="发送时间" align="center">
                <template slot-scope="{ row }">
                  {{ fakeMsgSendAt(row.send_time) }}
                </template>
              </el-table-column>

              <el-table-column prop="user_id" label="用户ID" align="center"></el-table-column>
              <el-table-column prop="user_name" label="用户昵称" align="center"></el-table-column>
              <el-table-column label="头像" align="center">
                <template slot-scope="{ row }">
                  <img :src="row.user_avatar" style="width: 30px" alt="" />
                </template>
              </el-table-column>
              <!-- <el-table-column label="用户角色" align="center">
                <template slot-scope="{ row }">{{
                    row.user_role == 0 ? '学员' : (row.user_role == 1 ? '讲师' : '助教')
                  }}
                </template>
              </el-table-column> -->
              <el-table-column label="消息状态" align="center">
                <template slot-scope="{ row }">{{
                  row.status == 1 ? '待提交' : (row.status == 2 ? '已提交' : (row.status == 3 ? '发送成功' : '发送失败'))
                }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="{ row }">
                  <el-button v-if="row.status == 1 && row.content_type == 1" type="text" size="mini"
                    @click="openFakeMsgDialog(row)">
                    修改
                  </el-button>
                  <el-button v-if="row.status == 1" type="danger" size="mini" @click="delFakeMsg(row.id)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <div class="block">
                <el-pagination background @current-change="getFakeChatMsg" :current-page.sync="fakeChatMsgQuery.page"
                  :page-size="fakeChatMsgQuery.limit" layout="total, prev, pager, next, jumper"
                  :total="fakeChatMsgList.total">
                </el-pagination>
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="问答信息" name="qaStat">
            <el-table :data="qaStat" v-loading="qaStatLoading" :stripe="true" border :span-method="qaStatSpanMethod"
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="qa_id" label="ID" align="center"></el-table-column>
              <el-table-column label="类型" align="center" width="450">
                <template slot-scope="{ row }">
                  <span v-if="row.is_answer == 0" style="color: #E6A23C"><i class="el-icon-question"></i> 提问：</span>
                  <span v-else style="color: #67C23A"><i class="el-icon-info"></i> 回答：</span>
                  <span>{{ row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="number" label="用户ID" align="center"></el-table-column>
              <el-table-column prop="name" label="用户昵称" align="center"></el-table-column>
              <el-table-column label="用户角色" align="center">
                <template slot-scope="{ row }">
                  {{ row.user_role == 0 ? '学员' : (row.user_role == 1 ? '讲师' : '助教') }}
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="时间" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="课前问卷" name="questionnaireStat" v-if="0 == 1">
            <el-table :data="questionnaireStat" v-loading="questionnaireStatLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="content" label="内容"></el-table-column>
              <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="课中测试" name="roomQuiz">
            <el-table :data="roomQuiz" v-loading="roomQuizLoading" :stripe="true" border
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="quiz_id" label="试卷ID" align="center"></el-table-column>
              <el-table-column prop="title" label="试卷标题" align="center"></el-table-column>
              <el-table-column label="是否强制参加" align="center">
                <template slot-scope="{ row }">{{ row.force_join == 0 ? '强制' : '非强制' }}</template>
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间" align="center"></el-table-column>
              <el-table-column label="操作" align="center" width="250">
                <template slot-scope="{ row }">
                  <el-button type="warning" size="small"
                    @click="openQuizUserAnswerDialog(row.quiz_id, row.question_list)">学员答案
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="答题器数据" name="answerStat">
            <el-table :data="answerStat" border v-loading="answerStatLoading" style="width: 100%; margin-top: 15px"
              size="small">
              <el-table-column prop="description" label="问题描述" align="center"></el-table-column>
              <el-table-column label="答题时长" align="center">
                <template slot-scope="{ row }">
                  {{ commonUtil.formatSeconds(row.question_end_time - row.question_start_time) }}
                </template>
              </el-table-column>
              <el-table-column prop="option_string" label="答案选项" align="center"></el-table-column>
              <el-table-column prop="right_option" label="正确答案" align="center"></el-table-column>
              <el-table-column prop="student_count" label="参与人数" align="center"></el-table-column>
              <el-table-column prop="student_correct_count" label="正确人数" align="center"></el-table-column>
              <el-table-column prop="student_correct_rate" label="正确率" align="center"></el-table-column>
            </el-table>
            <div style="margin-top: 15px">
              <el-pagination layout="total, prev, pager, next, jumper" background @current-change="getEvaluationStat"
                :current-page.sync="answerStatQuery.page" :page-size="answerStatQuery.limit"
                :total="answerStatTotal"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="课后评价" name="getEvaluationStat">
            <el-table :data="evaluationStat" :span-method="evaluationStatMethod" border
              v-loading="evaluationStatLoading" style="width: 100%; margin-top: 15px" size="small">
              <el-table-column label="用户" align="center">
                <template slot-scope="{ row }">
                  <div>昵称：{{ row.user_name }}</div>
                  <div>用户ID：{{ row.user_number }}</div>
                </template>
              </el-table-column>
              <el-table-column label="内容" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.title }} {{ row.answer }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="create_time" label="时间" align="center"></el-table-column>
            </el-table>
            <div style="margin-top: 15px">
              <el-pagination layout="total, prev, pager, next, jumper" background @current-change="getEvaluationStat"
                :current-page.sync="evaluationStatQuery.page" :page-size="evaluationStatQuery.limit"
                :total="evaluationStatTotal"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="专注度检测" name="attentionList">
            <el-table :data="attentionList" border v-loading="attentionListLoading"
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="user_number" label="用户ID" align="center" fixed></el-table-column>
              <el-table-column prop="user_name" label="昵称" align="center" fixed></el-table-column>
              <el-table-column prop="attention_level" label="状态" align="center" fixed></el-table-column>
              <el-table-column prop="client_type" label="客户端类型" align="center" fixed></el-table-column>
              <el-table-column label="时间" align="center">
                <template slot-scope="{ row }">{{ commonUtil.dateFormat('Y-m-d H:i:s', row.ts) }}</template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 15px">
              <el-pagination layout="total, prev, pager, next, jumper" background @current-change="getEvaluationStat"
                :current-page.sync="attentionListQuery.page" :page-size="attentionListQuery.limit"
                :total="attentionListTotal"></el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane label="点赞统计" name="praiseStat">
            <el-table :data="praiseStat" border v-loading="praiseStatLoading" style="width: 100%; margin-top: 15px"
              size="small">
              <el-table-column prop="user_number" label="用户ID" align="center" fixed></el-table-column>
              <el-table-column prop="user_name" label="昵称" align="center" fixed></el-table-column>
              <el-table-column prop="count" label="总数" align="center" fixed></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="分享统计" name="shareClickList" v-if="0 == 1">
            <el-table :data="shareClickList" border v-loading="shareClickListLoading"
              style="width: 100%; margin-top: 15px" size="small">
              <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
              <el-table-column prop="number" label="分享次数" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
          <!--          <el-tab-pane label="礼物统计" name=""></el-tab-pane>-->
        </el-tabs>
        <!--        </el-card>-->
      </el-col>
    </el-row>

    <el-dialog title="发放奖品列表" :visible.sync="giveProductListDialog" width="80%" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px">
        <el-input class="search-el" size="small" v-model="giveProductListQuery.mobile" placeholder="手机号"></el-input>
        <el-select class="search-el" size="small" v-model="giveProductListQuery.status" placeholder="类型">
          <el-option label="待发放" :value="0"></el-option>
          <el-option label="已发放" :value="1"></el-option>
        </el-select>
        <el-button plain icon="el-icon-refresh" size="small" @click="getGiveProductList()"
          :loading="giveProductListLoading">搜索
        </el-button>
        <el-button type="warning" icon="el-icon-receiving" size="small" @click="handleGiveProduct"
          :loading="handleInfoGiveLoading">
          开始发放奖励
        </el-button>
      </div>
      <h4 v-show="handleInfoGiveLoading"><i class="el-icon-loading"></i> 剩余{{ giveProductListTotal }}处理中...
        ({{ sec }}秒后自动刷新列表)</h4>
      <el-table v-loading="giveProductListLoading" :data="giveProductList" border size="mini" :stripe="true">
        <el-table-column prop="user_id" label="用户ID" align="center"></el-table-column>
        <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
        <el-table-column prop="give_type" label="类型" align="center"></el-table-column>
        <el-table-column prop="give_title" label="内容" align="center"></el-table-column>
        <el-table-column prop="give_title_id" label="内容ID" align="center"></el-table-column>
        <el-table-column label="新用户" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.is_new_user == 1" style="color:#67C23A"><i class='el-icon-user-solid'></i> 新用户</span>
              <span v-else style="color:#909399"><i class='el-icon-user'></i> 老用户</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="old_end_at" label="发放前到期时间" align="center" width="200"></el-table-column>
        <el-table-column prop="updated_at" label="处理时间" align="center" width="200"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{row}">
            <div>
              <span v-if="row.give_status == 1" style="color:#67C23A">已发放</span>
              <span v-else style="color:#909399">待发放</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="total_price" label="金额" align="center"></el-table-column>
        <el-table-column prop="user_code" label="用户唯一码" align="center"></el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="{row}" v-if="row.give_status == 0">
            <el-button type="danger" size="small" @click="delActivityGiveLogAction('s', giveProductListType, row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination background @current-change="getGiveProductList" :current-page.sync="giveProductListQuery.page"
          :page-size="giveProductListQuery.limit" layout="total, prev, pager, next, jumper"
          :total="giveProductListTotal">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="绑定产品"
      :visible.sync="bindProductDialog" width="50%">
      <el-form ref="form" :model="bindProductInfo" label-width="80px" @submit.native.prevent>
        <el-form-item label="产品类型">
          <el-radio-group v-model="bindProductInfo.type" @change="changeBindProductType">
            <el-radio label="课程">课程</el-radio>
            <el-radio label="专题课">专题课</el-radio>
            <el-radio label="会员">会员</el-radio>
            <el-radio label="优惠券">优惠券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="bindProductInfo.type + 'ID'" v-if="bindProductInfo.type != '会员'">
          <el-input v-model="bindProductInfo.id" size="small" style="width: 100px; margin-right: 15px"
            type="number"></el-input>
          <el-button type="primary" size="small" @click="getBindProductSimpleInfo()"
            :loading="getBindProductSimpleInfoLoading">查询
          </el-button>
        </el-form-item>
        <el-form-item :label="bindProductInfo.type + 'ID'" v-else>
          <el-select v-model="bindProductInfo.id" placeholder="请选择">
            <el-option label="年会员" :value="10"></el-option>
            <el-option label="季会员" :value="6"></el-option>
            <el-option label="月会员" :value="4"></el-option>
            <el-option label="半月会员" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信息" v-if="bindProductInfo.product_info.title != ''">
          <div style="display: flex">
            <el-image style="width: 100px; margin-right: 15px;" :src="bindProductInfo.product_info.img_url"
              fit="cover"></el-image>
            <span>{{ bindProductInfo.product_info.title }}</span>
          </div>
        </el-form-item>
        <el-form-item label="发送短信">
          <el-select v-model="bindProductInfo.sms" placeholder="请选择" size="small" style="margin-right: 15px">
            <el-option label="无短信" value=""></el-option>
            <el-option label="发放课程短信" :value="277"></el-option>
            <el-option label="直播间购买短信" :value="268"></el-option>
            <el-option label="直播间中奖短信" :value="269"></el-option>
          </el-select>
          <el-popover placement="top-start" title="短信提示" width="350" trigger="hover">
            <div>
              <b>[ 发放课程模板 ]</b> 您在直播间获得的课程已经开通到您的灵动生活APP账号，请尽快至：灵动生活APP-我的-已购-课程目录内 添加助教进行学习
            </div>
            <div>
              <b>[ 直播间购买短信 ]</b>
              您在视频号直播间购买的课程已开通，请点击链接https://wap.zhangdefenspace.com/appPage/AppDownload.html?user_code%3D5
              下载灵动生活APP到我的已购进行查看！
            </div>
            <div>
              <b>[ 直播间中奖短信 ]</b>
              您在直播间获得的礼品已开通，请点击链接https://wap.zhangdefenspace.com/appPage/AppDownload.html?user_code%3D5
              下载灵动生活APP到我的已购进行查看！
            </div>
            <el-button slot="reference" type="text" size="small" icon="el-icon-info">短信模板信息</el-button>
          </el-popover>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="bindProductInfoSubmit()" :loading="bindProductInfoSubmitLoading"
            size="small">立即绑定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="中奖名单"
      :visible.sync="showAwardUserListDialog" width="50%">
      <el-table :data="showAwardUserList" :stripe="true" border style="width: 100%; margin-top: 15px" size="small">
        <el-table-column prop="user_number" label="用户ID" align="center"></el-table-column>
        <el-table-column prop="user_name" label="用户名" align="center"></el-table-column>
        <el-table-column prop="mobile" label="用户名填写的手机号" align="center"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="学员答案"
      :visible.sync="showQuizUserAnswerDialog" width="80%">
      <div style="margin-bottom: 15px">
        <!--        <ExportExcel btn="导出学员答案" excel-file-name="学员答案" element-class-name=".export-table"></ExportExcel>-->
      </div>
      <el-table :data="quizUserAnswer" :span-method="quizUserAnswerMethod" v-loading="quizUserAnswerLoading"
        :stripe="true" border style="width: 100%; margin-top: 15px" size="small" class="export-table">
        <el-table-column label="用户" align="center">
          <template slot-scope="{ row }">
            <div>昵称：{{ row.user_name }}</div>
            <div>用户ID：{{ row.user_number }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="题型" align="center"></el-table-column>
        <el-table-column prop="title" label="问题" align="center" width="350"></el-table-column>
        <el-table-column prop="answer" label="用户答案" align="center">
          <template slot-scope="{ row }">
            <div v-for="(item, index) in row.answer" :key="index">
              <div v-if="item.is_right == '正确'" style="color: #67C23A">{{ item.value }}；</div>
              <div v-else-if="item.is_right == '错误'" style="color: #F56C6C">{{ item.value }}；</div>
              <div v-else>{{ item.value }}；</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="得分" align="center"></el-table-column>
      </el-table>
    </el-dialog>

    <live-room-info ref="roomInfo"></live-room-info>

    <live-embed-video ref="embedVideo"></live-embed-video>

    <el-dialog title="修改消息" :visible.sync="dialogVisibleFakeMsg" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="addEditFormOnCloseFakeMsg" width="50%">
      <el-form :model="newFakeMsg" label-width="100px" class="demo-ruleForm">
        <el-form-item label="内容">
          <el-input type="textarea" :rows="2" v-model="newFakeMsg.content" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item label="发送时间">
          <el-radio-group v-model="newFakeMsg.isAfter">
            <el-radio :label="0" value="0">开播前</el-radio>
            <el-radio :label="1" value="1">开播后</el-radio>
          </el-radio-group>

          <el-time-picker v-model="newFakeMsg.send_time" format='HH:mm:ss' value-format='HH:mm:ss'>
          </el-time-picker>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" @click="addEditFormOnCloseFakeMsg">取 消</el-button>
          <el-button size="mini" type="primary" @click="setNewFakeMsg()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="批量调整消息时间" :visible.sync="dialogBatchFakeMsgTime" :close-on-click-modal="false"
      :close-on-press-escape="false" :before-close="dialogBatchFakeMsgTimeClose" width="50%">
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="操作">
          <el-radio-group v-model="batchMsg.action">
            <el-radio :label="0" value="0">提前</el-radio>
            <el-radio :label="1" value="1">推迟</el-radio>
          </el-radio-group>

          <el-time-picker v-model="batchMsg.second" format='HH:mm:ss' value-format='HH:mm:ss'>
          </el-time-picker>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" @click="dialogBatchFakeMsgTime = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="setBatchMsg()">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>
<script>
import {
  bindAwardProduct,
  deleteLiveBindProduct,
  exportAnswerStat,
  exportRoomPraiseStat,
  getAttentionList,
  getAwardStatList,
  getBindProductSimpleInfo,
  getChatMsg,
  exportChatMsgExcel,
  getEvaluationStat,
  getGiveProductList,
  getLiveCourseInfo,
  getQaStat,
  getQuestionnaireStat,
  getQuizUserAnswer,
  getRoomQuiz,
  getShareClickList,
  getUserCheckinInfo,
  handleGiveProduct,
  resetLiveStatus,
  userList,
  getFakeChatMsgList,
  delFakeMsg,
  insertQueue,
  replacePlayback,
  setNewFakeMsg,
  advanceStopLive,
  cleanFakeMessage,
  setBatchMsgTime
} from '@/api/live'
import { delActivityGiveLog } from "@/api/activityGive";

//"xlsx": "^0.17.1"
// import ExportExcel from "@/components/ExportExcel.vue"
import liveRoomInfo from "@/components/liveRoomInfo.vue";
import liveEmbedVideo from "@/components/liveEmbedVideo.vue";
import initLiveChatMessage from "@/components/initLiveChatMessage.vue";
import collect from "collect.js";
import { tableRowspan, formatSeconds, dateFormat } from "../../api/common";

export default {
  components: {
    liveRoomInfo, liveEmbedVideo,
    // ExportExcel,
    initLiveChatMessage
  },
  data: function () {
    return {
      domain: window.location.host,
      admin_id: this.$route.query.admin_id,
      id: '',
      period_id: '',
      courseType: 3, //课程类型，3-直播课，1-普通课
      loading: true,
      liveInfo: {},
      activeName: 'userList',
      userListInfo: [],
      userListInfoLoading: false,
      userListInfoTotal: 0,
      userListInfoQuery: {
        page: 1,
        limit: 20,
        room_id: "",
      },
      awardStatList: [],
      awardStatListLoading: false,
      awardStatListTotal: 0,
      awardStatListQuery: {
        room_id: "",
      },
      awardUserList: [],
      bindProductInfo: {
        room_id: '',
        bind_id: '',
        type: '课程',
        id: '',
        sms: '',
        product_info: {
          title: '',
          img_url: ''
        }
      },
      showAwardUserList: [],
      showAwardUserListDialog: false,
      getBindProductSimpleInfoLoading: false,
      bindProductDialog: false,
      bindProductInfoSubmitLoading: false,

      // 发放奖品列表
      giveProductListDialog: false,
      giveProductList: [],
      giveProductListTotal: 0,
      giveProductListQuery: {
        award_id: '',
        status: 0,
        mobile: '',
        page: 1,
        limit: 20,
      },
      giveProductListType: '',
      giveProductListLoading: false,
      handleInfoGiveLoading: false,
      timeId1: '',
      sec: 3,
      delActivityGiveLogLoading: false,
      roomInfo: {
        dialogVisible: false,
        period_id: 0
      },
      embedVideo: {
        chooseOrgVisible: false,
        id: 0,
        period_id: 0
      },
      userCheckinInfo: [],
      userCheckinInfoLoading: false,
      chatMsg: [],
      chatMsgLoading: false,
      qaStat: [],
      qaStatLoading: false,
      evaluationStat: [],
      evaluationStatLoading: false,
      evaluationStatQuery: {
        room_id: '',
        page: 1,
        limit: 20,
      },
      evaluationStatTotal: 0,
      praiseStat: [],
      praiseStatLoading: false,
      attentionList: [],
      attentionListLoading: false,
      attentionListTotal: 0,
      attentionListQuery: {
        room_id: '',
        begin_at: '',
        page: 1,
        limit: 20,
      },
      answerStat: [],
      answerStatTotal: 0,
      answerStatLoading: false,
      answerStatQuery: {
        room_id: '',
        page: 1,
        limit: 20,
      },
      roomQuiz: [],
      roomQuizLoading: false,
      questionList: [],
      quizUserAnswer: [],
      quizUserAnswerLoading: false,
      showQuizUserAnswerDialog: false,
      questionnaireStat: [],
      questionnaireStatLoading: false,
      shareClickList: [],
      shareClickListLoading: false,

      //假聊天消息
      fakeChatMsgLoading: false,
      fakeChatMsgQuery: {
        course_id: this.$route.query.id,
        period_id: this.$route.query.period_id,
        content: '',
        status: '',
        page: 1,
        limit: 10,
      },
      fakeChatMsgList: {
        total: 0,
        list: [],
      },

      dialogVisibleFakeMsg: false,
      newFakeMsg: {
        id: 0,
        content: "",
        send_time: 0,
        isAfter: 1
      },

      dialogBatchFakeMsgTime: false,
      batchMsg: {
        course_id: this.$route.query.id,
        period_id: this.$route.query.period_id,
        action: 0,
        second: '00:00:00'
      },
    }
  },
  created: function () {
    this.id = this.$route.query.id
    this.period_id = this.$route.query.period_id
    this.getInfo()
  },
  methods: {
    toBlessingBag (course_id, period_id) {
      this.$router.push({
        path: "/live/blessingBag/list",
        query: {
          course_id: course_id,
          period_id: period_id,
        },
      });
    },
    dialogBatchFakeMsgTimeClose () {
      this.dialogBatchFakeMsgTime = false;
      this.batchMsg = {
        course_id: this.$route.query.id,
        period_id: this.$route.query.period_id,
        action: 0,
        second: '00:00:00'
      };
    },
    setBatchMsg () {
      this.$confirm("此操作将对未提交的假消息发送时间批量调整，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setBatchMsgTime(this.batchMsg).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
            this.dialogBatchFakeMsgTimeClose();
            this.getFakeChatMsg();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });


    },
    //格式化假消息实际发送时间
    fakeMsgSendAt (second) {
      return dateFormat('m-d H:i:s', second + this.liveInfo.begin_at_timestamp);
    },
    advanceStopLive () {
      this.$confirm("此操作针对未到达结束时间的直播，将提前结束直播，触发生成回放（15~20分钟）。请确认是否提前结束直播，提交后不可撤回, 是否继续?（提示：点击确定后请勿重复点击！！！）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        advanceStopLive({
          course_id: this.id,
          period_id: this.period_id
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
    cleanFakeMessage () {
      this.$confirm('此操作将 清空本次伪直播假消息，是否确认清空？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cleanFakeMessage({ course_id: this.id, period_id: this.period_id }).then((res) => {
          if (res.code == 1) {
            this.$message({
              showClose: true,
              duration: 3000,
              message: '清空成功',
              type: 'success'
            });
            this.getFakeChatMsg();
            this.liveInfo.mock_live_fake_msg_count = 0;
          }
        });
      }).catch(() => {

      });
    },
    openFakeMsgDialog (fakeMsg) {
      this.dialogVisibleFakeMsg = true;
      this.newFakeMsg = {
        id: fakeMsg.id,
        content: fakeMsg.content,
        send_time: dateFormat('H:i:s', (Math.abs(fakeMsg.send_time) - 8 * 3600)),
        isAfter: fakeMsg.send_time > 0 ? 1 : 0
      };
    },
    setNewFakeMsg () {
      setNewFakeMsg(this.newFakeMsg)
        .then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
            this.addEditFormOnCloseFakeMsg();
            this.getFakeChatMsg();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
        });
    },
    addEditFormOnCloseFakeMsg () {
      this.dialogVisibleFakeMsg = false;
      this.newFakeMsg = {
        id: 0,
        content: "",
        send_time: 0,
        isAfter: 1
      };
    },
    replacePlaybackMsg () {
      this.$message({
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: '1.此操作 仅适用 于在百家云下载直播回放到本地剪辑，将剪辑重新上传百家云点播的 方式（请提供点播视频ID）；<br>2.在百家云后台直接剪辑回放，将剪辑好的视频设置为主版本即可，禁止该方式的回放通过此按钮替换。',
        type: 'warning',
        duration: 0
      });
    },
    replacePlayback () {
      this.$prompt("请输入百家云点播的 视频ID", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          replacePlayback({
            period_id: this.period_id,
            new_bjy_video_id: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });
    },

    insertFakeQueue () {
      this.$confirm("此操作将已选中的消息提交至直播间，提交后不可撤回, 是否继续?（提示：若消息超过2000条执行时间将超过1分钟，点击确定后请勿重复点击！！！）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.fakeChatMsgLoading = true;
        insertQueue({
          course_id: this.id,
          period_id: this.period_id
        }).then((response) => {
          if (response.status == 2000) {
            this.getFakeChatMsg();
            this.$message({
              showClose: true,
              message: "成功",
              type: "success",
            });
          } else {
            this.fakeChatMsgLoading = false;
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
    delFakeMsg (id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delFakeMsg({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getFakeChatMsg();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
    formatSecondShow (second) {
      return formatSeconds(Math.abs(second));
    },
    getFakeChatMsg () {
      this.fakeChatMsgLoading = true;
      getFakeChatMsgList(this.fakeChatMsgQuery).then((response) => {
        this.fakeChatMsgList.total = response.data.total
        this.fakeChatMsgList.list = response.data.list.map((item) => {
          // 图片消息
          if (item.content_type == 2) {
            item.content = item.content.replace('[img:', '').replace(']', '');
          }
          // 自定义消息
          if (item.content_type == 3) {
            item.content = JSON.parse(item.content.replace('#zhangdefenspace#', ''));
          }
          return item
        })
        this.fakeChatMsgLoading = false
      })
    },
    getShareClickList () {
      this.shareClickListLoading = true;
      getShareClickList({
        course_id: this.liveInfo.course_id,
        period_id: this.period_id,
      }).then((response) => {
        this.shareClickList = response.data
        this.shareClickListLoading = false
      })
    },
    getQuestionnaireStat () {
      this.questionnaireStatLoading = true;
      getQuestionnaireStat({ room_id: this.liveInfo.room_id }).then((response) => {
        let tempUserAnswerList = response.data.user_answer_list;
        let tempQuestionList = collect(response.data.question).keyBy('question_id');
        let tempData = [];
        for (let i = 0; i < tempUserAnswerList.length; i++) {
          tempData[i] = {
            content: collect(tempUserAnswerList[i]).map((item, index) => {
              let t_t = tempQuestionList.get(index).title.replace('：', '');
              return t_t + '：' + item;
            }).values().implode('\n'),
          }
          tempData[i].create_time = response.data.question[0].create_time;
        }
        this.questionnaireStat = tempData;
        console.log(tempUserAnswerList, tempQuestionList, tempData);
        this.questionnaireStatLoading = false
      })
    },
    quizUserAnswerMethod ({ row, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan
        }
      }
    },
    getQuizUserAnswer (quiz_id) {
      this.quizUserAnswerLoading = true;
      getQuizUserAnswer({
        room_id: this.liveInfo.room_id,
        quiz_id: quiz_id
      }).then((response) => {
        let list = response.data.student_answer_list
        let tempList = [];
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < list[i].answer_list.length; j++) {
            let tempType = '';
            let question_id = list[i].answer_list[j].question_id;

            switch (this.questionList.get(question_id)['type']) {
              case 'judge_question':
                tempType = '判断题';
                break;
              case 'single_select':
                tempType = '单选题';
                break;
              case 'multi_select':
                tempType = '多选题';
                break;
              case 'question_answer':
                tempType = '问答题';
                break;
            }

            let answer = '';
            let score = '';
            if (tempType == '多选题') {
              let answerList = list[i].answer_list[j].answer.split(',');
              let answerTemp = [];
              let scoreTemp = 0;
              for (let n = 0; n < answerList.length; n++) {
                let is_right = this.questionList.get(question_id).option_list.get(answerList[n]).is_right == 1 ? '正确' : '错误';
                answerTemp.push({
                  value: this.questionList.get(question_id).option_list.get(answerList[n]).value,
                  is_right: is_right
                })
                scoreTemp += is_right == 1 ? this.questionList.get(question_id).option_list.get(answerList[n]).score : 0;
              }
              answer = answerTemp;
              score = scoreTemp;
            } else if (tempType == '问答题') {
              answer = [{
                value: list[i].answer_list[j].answer,
                is_right: '问答题'
              }];
              score = 0;
            } else {
              answer = [{
                value: this.questionList.get(question_id).option_list.get(list[i].answer_list[j].answer).value,
                is_right: this.questionList.get(question_id).option_list.get(list[i].answer_list[j].answer).is_right == 1 ? '正确' : '错误'
              }]
              score = this.questionList.get(question_id).option_list.get(list[i].answer_list[j].answer).score;
            }

            tempList.push({
              user_name: list[i].user_name,
              user_number: list[i].user_number,
              answer: answer,
              score: score,
              title: this.questionList.get(question_id).title,
              type: tempType,
            })
          }
        }
        this.quizUserAnswer = tableRowspan(tempList, 'user_number');
        this.quizUserAnswerLoading = false
      })
    },
    openQuizUserAnswerDialog (quiz_id, question_list) {
      console.log(question_list)
      this.showQuizUserAnswerDialog = true;
      this.questionList = [];
      this.questionList = collect(question_list).map(item => {
        item.option_list = collect(item.option_list).keyBy('option_id');
        return item;
      }).keyBy('question_id');
      this.getQuizUserAnswer(quiz_id);
    },
    getRoomQuiz () {
      this.roomQuizLoading = true;
      getRoomQuiz({ room_id: this.liveInfo.room_id }).then((response) => {
        this.roomQuiz = response.data.quiz_list
        this.roomQuizLoading = false
      })
    },
    exportAnswerStat () {
      this.answerStatLoading = true;
      this.answerStatQuery.room_id = this.liveInfo.room_id;
      exportAnswerStat(this.answerStatQuery).then((response) => {
        this.answerStat = response.data.list
        this.answerStat = collect(this.answerStat).map(item => {
          item.option_string = collect(item.option_list).implode('option', ',')
          let studentAnswer = collect(item.student_answer)
          item.student_count = studentAnswer.count()
          item.student_correct_count = studentAnswer.where('is_right', true).count()
          if (item.student_correct_count == 0) {
            item.student_correct_rate = 0;
          } else {
            item.student_correct_rate = (item.student_correct_count / item.student_count * 100).toFixed(2) + '%'
          }
          return item;
        }).toArray();
        this.answerStatTotal = response.data.total
        this.answerStatLoading = false
      })
    },
    getAttentionList () {
      this.attentionListLoading = true;
      this.attentionListQuery.room_id = this.liveInfo.room_id;
      this.attentionListQuery.date = this.liveInfo.begin_at.slice(0, 10);
      getAttentionList(this.attentionListQuery).then((response) => {
        this.attentionList = response.data.list
        this.attentionListTotal = response.data.total
        this.attentionListLoading = false
      })
    },
    exportRoomPraiseStat () {
      this.praiseStatLoading = true;
      exportRoomPraiseStat({ room_id: this.liveInfo.room_id }).then((response) => {
        this.praiseStat = response.data.list
        this.praiseStatLoading = false
      })
    },
    evaluationStatMethod ({ row, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 2) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan
        }
      }
    },
    getEvaluationStat () {
      this.evaluationStatLoading = true;
      this.evaluationStatQuery.room_id = this.liveInfo.room_id;
      getEvaluationStat(this.evaluationStatQuery).then((response) => {
        this.evaluationStat = tableRowspan(response.data.list, 'user_number');
        this.evaluationStatTotal = response.data.total;
        this.evaluationStatLoading = false
      })
    },
    qaStatSpanMethod ({ row, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan
        }
      }
    },
    getQaStat () {
      this.qaStatLoading = true;
      getQaStat({ room_id: this.liveInfo.room_id }).then((response) => {
        this.qaStat = tableRowspan(response.data.list[0], 'qa_id');
        this.qaStatLoading = false
      })
    },
    getChatMsg () {
      this.chatMsgLoading = true;
      getChatMsg({ room_id: this.liveInfo.room_id }).then((response) => {
        this.chatMsg = response.data.list
        this.chatMsgLoading = false
      })
    },
    exportChatMsgExcel () {
      this.chatMsgLoading = true;
      exportChatMsgExcel({ room_id: this.liveInfo.room_id }).then((res) => {
        const link = document.createElement("a");
        let blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = "聊天信息.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.chatMsgLoading = false;
      }).catch(err => {
        this.chatMsgLoading = false;
      });
    },
    getUserCheckinInfo () {
      this.userCheckinInfoLoading = true;
      getUserCheckinInfo({ room_id: this.liveInfo.room_id }).then((response) => {
        this.userCheckinInfo = response.data.checkin_list
        this.userCheckinInfoLoading = false
      })
    },
    resetLiveStatus () {
      resetLiveStatus({
        period_id: this.period_id,
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "成功",
            type: "success",
          });
          this.liveInfo.live_status = 0;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    toList () {
      // window.history.go(-1)
      this.$router.back()
      // this.$router.push({
      //   path: "/live/list",
      // });
    },
    toMessage (course_id, period_id) {
      this.$router.push({
        path: "/live/message",
        query: {
          course_id: course_id,
          period_id: period_id
        },
      });
    },
    delActivityGiveLogAction (del, type, id) {
      delActivityGiveLog({
        del,
        type,
        id
      }).then(() => {
        this.getGiveProductList();
        this.$message({
          showClose: true,
          duration: 6000,
          message: '操作成功',
          type: 'success'
        });
      });
    },
    handleGiveProduct () {
      var that = this
      this.getGiveProductList();
      this.$message({
        showClose: true,
        duration: 6000,
        message: '开始处理',
        type: 'success'
      });
      handleGiveProduct({
        type: this.giveProductListType,
        award_id: this.giveProductListQuery.award_id
      }).then(res => {
        if (res.code == 1) {
          that.handleInfoGiveLoading = true
          that.timeId1 = window.setInterval(() => {
            that.sec = (that.sec - 0.1).toFixed(1)
            if (that.sec <= 0) {
              that.getGiveProductList();
              that.sec = 3
            }
            if (that.giveProductListTotal == 0) {
              that.$message({
                showClose: true,
                duration: 6000,
                message: '处理完成',
                type: 'success'
              });
              that.handleInfoGiveLoading = false
              clearInterval(that.timeId1)
            }
          }, 100)
        }
      });
    },
    getGiveProductList () {
      this.giveProductListLoading = true;
      getGiveProductList(this.giveProductListQuery).then((response) => {
        this.giveProductList = response.data.list
        this.giveProductListTotal = response.data.total
        this.giveProductListType = response.data.type
        this.giveProductListLoading = false
      })
    },
    showGiveProductListDialog (awardId) {
      this.giveProductListDialog = true;
      this.giveProductListQuery.award_id = awardId;
      this.getGiveProductList();
    },
    deleteLiveBindProduct (awardId) {
      this.$confirm('此操作将 删除已绑定的产品，同时删除发放奖品列表中所有学员，是否确认删除 ？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteLiveBindProduct({ award_id: awardId }).then((res) => {
          if (res.code == 1) {
            this.$message({
              showClose: true,
              duration: 3000,
              message: '删除成功',
              type: 'success'
            })
          }
          this.getAwardStatList();
        });
      }).catch(() => {

      });
    },
    bindProductInfoSubmit () {
      this.bindProductInfoSubmitLoading = true;
      bindAwardProduct(this.bindProductInfo).then((res) => {
        if (res.code == 1) {
          this.bindProductInfoSubmitLoading = false;
          this.$message({
            showClose: true,
            duration: 6000,
            message: '绑定成功',
            type: 'success'
          });
          this.bindProductDialog = false;
          this.getAwardStatList();
        } else {
          this.bindProductInfoSubmitLoading = false;
        }
      }).cache(() => {
        this.bindProductInfoSubmitLoading = false;
      })
    },
    showBindProductDialog (bindId) {
      this.bindProductDialog = true;
      this.bindProductInfo = {
        room_id: '',
        bind_id: '',
        type: '课程',
        id: '',
        sms: '',
        product_info: {
          title: '',
          img_url: ''
        }
      };
      this.bindProductInfo.room_id = this.liveInfo.room_id;
      this.bindProductInfo.bind_id = bindId;
    },
    showAwardUser (list) {
      this.showAwardUserListDialog = true;
      this.showAwardUserList = list;
    },
    changeBindProductType (value) {
      this.bindProductInfo.product_info.title = '';
      this.bindProductInfo.product_info.img_url = '';
      if (value == '会员') {
        this.bindProductInfo.id = 4;
      } else {
        this.bindProductInfo.id = '';
      }
    },
    getBindProductSimpleInfo () {
      this.getBindProductSimpleInfoLoading = true;
      getBindProductSimpleInfo(this.bindProductInfo).then((response) => {
        this.bindProductInfo.product_info = response.data;
        this.getBindProductSimpleInfoLoading = false
      })
    },
    getAwardStatList () {
      this.awardStatListLoading = true
      this.awardStatListQuery.room_id = this.liveInfo.room_id
      getAwardStatList(this.awardStatListQuery).then((response) => {
        this.awardStatList = response.data.list
        this.awardStatListLoading = false
      })
    },
    getInfo () {
      this.loading = true
      getLiveCourseInfo({
        id: this.id,
        period_id: this.period_id,
      }).then((response) => {
        this.liveInfo = response.data
        this.liveInfo.begin_at_timestamp = Date.parse(this.liveInfo.begin_at) / 1000;
        this.loading = false
        this.userList()
      })
    },
    handleClick (tab) {
      switch (tab.name) {
        case 'shareClickList':
          this.getShareClickList();
          break;
        case 'questionnaireStat':
          this.getQuestionnaireStat();
          break;
        case 'roomQuiz':
          this.getRoomQuiz();
          break;
        case 'attentionList':
          this.getAttentionList();
          break;
        case 'answerStat':
          this.exportAnswerStat();
          break;
        case 'praiseStat':
          this.exportRoomPraiseStat();
          break;
        case 'getEvaluationStat':
          this.getEvaluationStat();
          break;
        case 'userList':
          this.userList();
          break;
        case 'prizeList':
          this.getAwardStatList();
          break;
        case 'userCheckinInfo':
          this.getUserCheckinInfo();
          break;
        case 'chatMsg':
          this.getChatMsg();
          break;
        case 'fakeChatMsg':
          this.getFakeChatMsg();
          break;
        case 'qaStat':
          this.getQaStat();
          break;
      }
    },
    userList () {
      this.userListInfoLoading = true
      this.userListInfoQuery.room_id = this.liveInfo.room_id
      userList(this.userListInfoQuery).then((response) => {
        this.userListInfo = response.data.room_user_info
        this.userListInfoTotal = response.data.total
        this.userListInfoLoading = false
      })
    },
    formatSeconds (result) {
      let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
      return result = h + ":" + m + ":" + s;
    }
  },
}
</script>
<style>
.el-table .cell {
  white-space: pre-line;
}

.el-table__expanded-cell[class*=cell] {
  padding: 0 0 0 50px;
}

.el-skeleton-item-button {
  width: 10%;
  margin-right: 10px;
}

.block {
  margin-top: 15px;
}
</style>